/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type BalanceEdit_userManagement$ref: FragmentReference;
declare export opaque type BalanceEdit_userManagement$fragmentType: BalanceEdit_userManagement$ref;
export type BalanceEdit_userManagement = {|
  +currentUser: ?{|
    +name: ?string,
    +avatarUrl: ?string,
  |},
  +$refType: BalanceEdit_userManagement$ref,
|};
export type BalanceEdit_userManagement$data = BalanceEdit_userManagement;
export type BalanceEdit_userManagement$key = {
  +$data?: BalanceEdit_userManagement$data,
  +$fragmentRefs: BalanceEdit_userManagement$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "BalanceEdit_userManagement",
  "type": "UserManagement",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "currentUser",
      "storageKey": null,
      "args": null,
      "concreteType": "UserManagementUser",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "name",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "avatarUrl",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'a60c9eb716a8f956c88684419dc5449b';
module.exports = node;
